import React, { useEffect } from 'react'
import { Row, Spinner } from 'react-bootstrap' 
// import data from '../../../data/index'
import Item from '../../../components/item/Item.js'
// import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
  getAllItems,
  selectNewHotItems,
  selectPage,
  selectItemPerPage,
  setPage,
  setItemPerPage
} from '../../../slice/itemSlice.js'


const Items = () => {
  
  const dispatch = useDispatch();
  
  const page = useSelector(selectPage);
  const iPP = useSelector(selectItemPerPage);
  const items = useSelector(selectNewHotItems);
  
  useEffect(() => {
    dispatch(getAllItems())
    dispatch(setPage(1))
    dispatch(setItemPerPage(12))
  }, [])

  return (
    <Row className=''>
      {items.length === 0 && <Spinner animation="border" variant="info" />}
      {items.slice((page-1)*iPP, page*iPP).map(d => <Item key={d.id} subCategory={d.subCategory} name={d.name} tag={d.tag} image={d.image} price={d.price} id={d.id}/>)}
    </Row>
  )
}

export default Items